const topicItems = [
  { name: '大赛吃瓜', count: '128.6万' },
  { name: '黑料吃瓜群', count: '96.3万' },
  { name: '每日吃瓜爆料', count: '85.7万' },
  { name: '大赛八卦', count: '74.2万' },
  { name: '黑料围观', count: '68.9万' },
  { name: '黑料吃瓜', count: '62.1万' },
  { name: '每日黑料最新', count: '55.4万' },
  { name: '大赛内幕', count: '48.8万' },
  { name: '选秀内幕', count: '42.3万' },
  { name: '电竞爆料', count: '37.6万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            话题标签
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料热门话题，吃瓜群众最关心的关键词都在这里
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 bg-background-50 border border-background-200/60 hover:border-primary-300 rounded-full cursor-pointer transition-all hover:bg-primary-50"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}